import { Modal } from 'antd';

export default function SummaryModal({
  show,
  onCancel,
  children,
  title,
  width = 650,
  height,
  closable,
  key,
  closeIcon,
  maskClosable,
}) {
  return (
    <Modal
      maskClosable={maskClosable}
      className="rounded-[30px] overflow-hidden "
      height={height}
      title={title}
      width={width}
      open={show}
      footer={null}
      onCancel={onCancel}
      closable={closable}
      key={key}
      closeIcon={closeIcon}
    >
      <div className="flex justify-center">{children}</div>
    </Modal>
  );
}
